import React from 'react';
import { Box, Grid, Button, Container, Typography } from '@material-ui/core';
import i18n from 'i18n-js';
import Can from 'components/Can';
import Layout from 'components/Layout';
import useStyles from './SkuDetails.styled';
import { withRouter, useParams } from 'react-router-dom';
import { SkuDetails as Details, SkuAccounting, SkuBehaviour } from 'components/Skus';
import { buildUrl } from 'utils';
import { useDispatch } from 'react-redux';
import { SkusActions } from 'state/modules/skus';
import { AssociatedTaxRuleset } from '../../../components/TaxRuleset/TaxRulesetHistory';
import { useSelector } from 'react-redux';

const SkuDetails = ({ history }) => {
  const classes = useStyles();
  const { id } = useParams();
  const dispatch = useDispatch();
  const TRSEnabled = useSelector(
    (state) => state.config.settings?.core?.pricing?.tax_rules_set?.enabled || false
  );

  return (
    <Layout title={i18n.t('skus.title')}>
      <Container className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container direction="row" justifyContent="space-between" spacing={2}>
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  <Box fontWeight="fontWeightBold" fontSize={24} my={1}>
                    {i18n.t('skus.sku_details')}
                  </Box>
                </Typography>
              </Grid>
              <Grid item>
                <Can I="create" a="invoice_item_type">
                  <Button
                    onClick={() => {
                      dispatch(SkusActions.resetOnboarding());
                      history.push(buildUrl('/skus/create'));
                    }}
                    style={{ textTransform: 'capitalize' }}
                    variant="contained"
                    color="primary"
                  >
                    {i18n.t('skus.create')}
                  </Button>
                </Can>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Details id={id} />
                  </Grid>
                  {TRSEnabled ? (
                    <Grid item xs={12}>
                      <AssociatedTaxRuleset skuId={id} />
                    </Grid>
                  ) : null}
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Can I="read" on="invoice_item_type">
                    <Grid item xs={12}>
                      <SkuAccounting id={id} />
                    </Grid>
                  </Can>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Can I="read" on="invoice_item_type">
                    <Grid item xs={12}>
                      <SkuBehaviour id={parseInt(id)} />
                    </Grid>
                  </Can>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default withRouter(SkuDetails);
